"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _mapPositionUtils = require("../util/mapPositionUtils");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/BoundaryManager/DrawSearchBoundary.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DrawSearchBoundary =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(DrawSearchBoundary, _PureComponent);

  function DrawSearchBoundary(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      screenHeight: 0,
      screenWidth: 0
    };
    return _this;
  }

  var _proto = DrawSearchBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* eslint-disable no-restricted-globals */
    this.setState({
      screenHeight: screen.height,
      screenWidth: screen.width
    });
    /* eslint-enable */
  };

  _proto.renderPaths = function renderPaths() {
    var fillClassName = this.props.fillCompletedRegion ? 'fill-region' : 'no-fill-region';
    return this.props.polygons.map(function (polygon) {
      return _react.default.createElement("path", {
        key: (0, _mapPositionUtils.getCustomRegionPolygonKey)(polygon),
        className: "poly-region custom-region " + fillClassName,
        d: (0, _mapPositionUtils.getPathLineFromCoordinateArray)(polygon),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        },
        __self: this
      });
    });
  };

  _proto.render = function render() {
    if ((0, _isEmpty2.default)(this.props.polygons)) {
      return null;
    } // SXP-3127: Hack to fix SVG not being drawn correctly on webkit browsers.
    // If the height/width of the container of an svg or the svg itself is not large enough
    // to contain the path, the path height and width are calculated incorrectly which
    // causes the SVG to be drawn incorrectly.


    var style = {
      minHeight: this.state.screenHeight,
      minWidth: this.state.screenWidth
    };
    return _react.default.createElement("div", {
      className: "full-boundary-container",
      style: _objectSpread({}, this.props.style, style),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55
      },
      __self: this
    }, _react.default.createElement("svg", {
      className: "full-boundary-svg",
      style: style,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56
      },
      __self: this
    }, this.renderPaths()));
  };

  return DrawSearchBoundary;
}(_react.PureComponent);

DrawSearchBoundary.propTypes = process.env.NODE_ENV !== "production" ? {
  style: _propTypes.default.object,
  polygons: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.number)),
  fillCompletedRegion: _propTypes.default.bool
} : {};
DrawSearchBoundary.defaultProps = {
  style: {},
  polygons: [],
  fillCompletedRegion: true
};
var _default = DrawSearchBoundary;
exports.default = _default;